import { z } from 'zod'

export const answerObject = z.object({
  id: z.string().describe('ID'),
  questionId: z.string().describe('ID da pergunta').nullish(),
  answerSheetId: z.string().describe('ID da folha de respostas').nullish(),
  string: z.string().describe('Resposta em texto').nullish(),
  number: z.string().describe('Resposta numérica').nullish(),
  boolean: z.string().describe('Resposta booleana').nullish(),
  date: z.string().describe('Resposta de data').nullish(),
  array: z.string().describe('Resposta em array').nullish(),
})
